/* global globalThis */
// Browser polyfills required by @solana/web3.js under webpack 5 (CRA 5),
// which no longer injects Node core shims automatically.
import { Buffer } from "buffer";

if (typeof window !== "undefined" && !window.Buffer) {
  window.Buffer = Buffer;
}
if (typeof globalThis !== "undefined" && !globalThis.Buffer) {
  globalThis.Buffer = Buffer;
}
